import styled from 'styled-components';

const FormWrapper = styled.div`
  width: 600px;
  padding: 25px 50px;
  border-radius: 2px;
  background: #ffffff;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export default FormWrapper;
